import { httpClient, mountUrl } from '@locaweb/design-system-vue'

const BASE_URL = '/api/v1/plans'
const CONSUMPTION = `${BASE_URL}/$id/consumption`

const findAll = () => {
  return httpClient.get(BASE_URL)
}

const findConsumption = (id) => {
  return httpClient.get(mountUrl(CONSUMPTION, { id }))
}
export {
  findAll,
  findConsumption
}
